import { getCookie } from 'tiny-cookie';

/**
 * TEMPORARY — remove once Meta approves the "Trackian Login" app's App Review
 * for `public_profile` + `email`.
 *
 * Until then Facebook Login only works for people with a role on the Meta app;
 * everyone else gets Facebook's "Feature unavailable" page. So the Facebook
 * button stays hidden unless the visitor came through
 * trackian.app/login?withMeta=true or /register?withMeta=true, which set this
 * cookie on the parent `trackian.app` domain (Trackian/Trackian,
 * frontend/v3/src/utils/meta-review-flag.ts). A cookie because Logto core drops
 * unknown auth params before this page loads.
 *
 * Only the rendered button list is filtered: direct sign-in and the social
 * callback still resolve the connector, so a sign-in already under way never
 * breaks if the cookie expires mid-flow.
 */
const metaReviewCookieKey = 'trackian_meta_review';

export const metaReviewGatedTargets = new Set(['facebook']);

export const isMetaReview = () => getCookie(metaReviewCookieKey) === '1';
